// create the module before importing the sub-resources, as they don't each
// make their own angular module because reasons
let module = angular.module('app.views', []);

// The act of importing these actually registers them with the angular module
// from above, so we're good to go at this point.
require('./account/account_branded_apps_controller');
require('./account/account_controller');
require('./account/account_donation_controller');
require('./account/account_donations_controller');
require('./account/account_form_controller');
require('./account/account_static_rtmps_controller');
require('./account/account_static_rtmp_controller');
require('./account/account_storage_bills_controller');
require('./account/change_subscription_form_controller');
require('./accounts/accounts_controller');
require('./activation_codes/activation_codes_controller');
require('./boxcaster/boxcaster_controller');
require('./boxcaster/boxcaster_form_controller');
require('./boxcaster/boxcaster_inventory_form_controller');
require('./boxcaster/boxcaster_register_form_controller');
require('./boxcasters/boxcasters_controller');
require('./boxcasters/boxcasters_new_mfg_controller');
require('./broadcast/broadcast_controller');
require('./broadcasts/broadcasts_controller');
require('./channel/channel_controller');
require('./channel/channel_ticket_controller');
require('./dashboard/dashboard_controller');
require('./extended_tests/extended_tests_controller');
require('./navigation/navigation_controller');
require('./order/order_controller');
require('./order/order_form_controller');
require('./orders/orders_controller');
require('./origins/confirm_termination_controller');
require('./origins/origin_controller');
require('./origins/origins_controller');
require('./scoreboard_assist/scoreboard_assist_controller');
require('./scoreboard_assists/scoreboard_assists_controller');
require('./scoreboard_assists/scoreboard_assists_new_mfg_controller');
require('./storage_bill/storage_bill_controller');
require('./storage_bills/storage_bills_controller');
require('./suppressed_email/suppressed_email_controller');
require('./suppressed_emails/suppressed_emails_controller');
require('./ticket/ticket_controller');
require('./tickets/tickets_controller');
require('./user/add_authorized_account_controller');
require('./user/user_controller');
require('./user/user_form_controller');
require('./users/users_controller');
require('./pandadoc/pandadoc_controller');

export default module;



// WEBPACK FOOTER //
// ./views/index.js